import React, { useState } from 'react';
import { ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
interface MobileCheckoutSummaryProps {
  subtotal: number;
  discount: number;
  tax: number;
  total: number;
  onCheckout: () => void;
}
export function MobileCheckoutSummary({
  subtotal,
  discount,
  tax,
  total,
  onCheckout
}: MobileCheckoutSummaryProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="md:hidden fixed bottom-16 left-0 right-0 z-40 bg-white border-t-2 border-gray-200 shadow-2xl" data-id="element-1552" data-mp="2g6mdeglvrxux">
      {/* Expanded Summary */}
      {isExpanded && <div className="px-4 pt-3 pb-2 border-b border-gray-200" data-id="element-1553" data-mp="2p6hv749xyr3x">
          <div className="mb-3" data-id="element-1554" data-mp="2p56oowp43594">
            <button onClick={() => setIsExpanded(false)} className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-1555" data-mp="2tx80yima4vz5">
              <span data-id="element-1556" data-mp="1whkdp3dk0yc8">Order Summary</span>
              <ChevronDownIcon className="w-4 h-4" data-id="element-1557" data-mp="21gf3wqdupp6d" />
            </button>
          </div>
          <div className="space-y-2 text-sm" data-id="element-1558" data-mp="1s2l2c8ih2g36">
            <div className="flex justify-between" data-id="element-1559" data-mp="1s1b6lpz3djzp">
              <span className="text-gray-600" data-id="element-1560" data-mp="1o19cq2zlluuz">Sub-Total (31 item(s))</span>
              <span className="font-medium" data-id="element-1561" data-mp="1o33wvf31piy0">SAR {subtotal.toFixed(2)}</span>
            </div>
            <div className="flex justify-between" data-id="element-1562" data-mp="1j86gfn3fs7b3">
              <span className="text-gray-600" data-id="element-1563" data-mp="1ebzl0o8o2e7e">Savings & Discount</span>
              <span className="font-medium text-red-600" data-id="element-1564" data-mp="19c3h0ozyymru">
                -SAR {discount.toFixed(2)}
              </span>
            </div>
          </div>
        </div>}
      {/* Main Summary Bar */}
      <div className="px-4 py-3" data-id="element-1565" data-mp="10b59vxu8hz51">
        <div className="flex items-center gap-3" data-id="element-1566" data-mp="10cgbps44cwti">
          {/* Expand Button */}
          {!isExpanded && <button onClick={() => setIsExpanded(true)} className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors flex-shrink-0" data-id="element-1567" data-mp="vdwprrpizl15">
              <ChevronUpIcon className="w-5 h-5 text-gray-600" data-id="element-1568" data-mp="2pr4m5nt5g4ow" />
            </button>}
          {/* Price Info */}
          <div className="flex-1 min-w-0" data-id="element-1569" data-mp="3dloieritula8">
            <div className="text-xs text-gray-500" data-id="element-1570" data-mp="3dmq4rs5amu79">(including VAT)</div>
            <div className="text-lg font-bold text-[#1E2B55]" data-id="element-1571" data-mp="2zutjo821lkkd">
              SAR {total.toFixed(2)}
            </div>
            <div className="text-xs text-red-600 font-medium" data-id="element-1572" data-mp="34ufwigdykysn">
              You saved SAR {discount.toFixed(2)}
            </div>
          </div>
          {/* Checkout Button */}
          <button onClick={onCheckout} className="bg-[#1E2B55] text-white font-bold py-3 px-6 rounded-lg hover:bg-[#162041] transition-colors flex-shrink-0" data-id="element-1573" data-mp="fogsmt707fo">
            Checkout
          </button>
        </div>
      </div>
    </div>;
}